import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  Col,
  Row,
  Tabs,
  Tab,
  ButtonToolbar,
  Modal,
  Dropdown,
} from "react-bootstrap";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
  CardHeaderTitle,
} from "../../../_metronic/_partials/controls";
import { LayoutSplashScreen } from "../../../_metronic/layout";
import { useSelector, useDispatch } from "react-redux";
import { useHistory, useParams } from "react-router-dom";
import {
  StatusFormatter,
  columnsExportExcel,
  dateDefault,
  formLabelsTheme,
  formatDate,
  formatQuantity,
  getValueOptions,
  iconError,
  showConfirmDialog,
  showDeleteDialog,
  showDialog,
  showErrorDialog,
  showSuccessDialog,
  sizePerPageList,
  statusInboundFormatter,
  useStyles,
  useStylesReddit,
} from "../../utility";
import BootstrapTable from "react-bootstrap-table-next";
import Select from "react-select";
import { fetchOffice, selectOffice } from "../office/officeSlice";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  NoRecordsFoundMessage,
  PleaseWaitMessage,
  sortCaret,
  toAbsoluteUrl,
  headerSortingClasses,
} from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";

import { makeStyles, fade, ThemeProvider } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import {
  fetchParameter,
  fetchParameter2,
  fetchParameter3,
  fetchParameter4,
  selectParameter,
  selectParameter2,
} from "../businessParameter/businessParameterSlice";
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  FormHelperText,
  MenuItem,
  Radio,
  RadioGroup,
} from "@material-ui/core";

import { fetchClient } from "../client/clientSlice";
import { selectPagination } from "../../modules/Auth";
import {
  editOutbound,
  editOutboundConfirm,
  editOutboundSetstatus,
  fetchIdOutbound,
  selectLoading,
  selectPageNo,
  selectPageSize,
  selectTotalRecord,
  selectIdOutbound,
  fetchOutbound,
  fetchOutboundParty,
  selectOutboundParty,
  selectPageNoParty,
  selectPageSizeParty,
  selectTotalRecordParty,
  removeOutboundParty,
  fetchOutboundVehicle,
  selectOutboundVehicle,
  removeOutboundVehicle,
  fetchOutboundTransportations,
  selectOutboundTransportations,
  selectPageNoTransportations,
  selectPageSizeTransportations,
  selectTotalRecordTransportations,
  removeOutboundTransportations,
  editOutboundStarWorkflow,
  editOutboundAmend,
  setPermisionPicking,
  setPermisionHandover,
  setPermisionBts,
  setPermisionList,
  fetchGenerateExcel
} from "./outboundSlice";
import moment from "moment";
import paginationFactory from "react-bootstrap-table2-paginator";
import { fetchCountryAll } from "../location/locationSlice";

import { Autocomplete } from "@material-ui/lab";
import { ModalCreateParty } from "./ModalCreateParty";
import { ModalCreateTranspotation } from "./ModalCreateTranspotation";
import { OutboundCancel } from "./OutboundCancel";
import { ModalCreateVehicle } from "./ModalCreateVehicle";
import { VehicleUpload } from "./VehicleUpload";
import { VehicleUploadView } from "../booking/VehicleUploadView";
import { ModalLocationMasterRadio } from "../inbound/ModalLocationMasterRadio";
import { ModalEditVehicle } from "./ModalEditVehicle";
import { fetchMenuTab, selectMenuTab } from "../menu/menuSlice";
// import { ModalCreateVehicle } from "./ModalCreateVehicle";
// import { ModalCreateParty } from "./ModalCreateParty";
// import { OutboundCancel } from "./OutboundCancel";
// import { ModalEditVehicle } from "./ModalEditVehicle";

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}

export const OutboundEdit = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();
  const loading = useSelector(selectLoading);
  const dataId = useSelector(selectIdOutbound);
  const dataParty = useSelector(selectOutboundParty);
  const dataVehicle = useSelector(selectOutboundVehicle);
  const dataTransportations = useSelector(selectOutboundTransportations);
  const pageNo = useSelector(selectPageNo);
  const pageSize = useSelector(selectPageSize);
  const totalRecord = useSelector(selectTotalRecord);
  const pageNoParty = useSelector(selectPageNoParty);
  const pageSizeParty = useSelector(selectPageSizeParty);
  const totalRecordParty = useSelector(selectTotalRecordParty);
  const pageNoTransportations = useSelector(selectPageNoTransportations);
  const pageSizeTransportations = useSelector(selectPageSizeTransportations);
  const totalRecordTransportations = useSelector(
    selectTotalRecordTransportations
  );

  const dataDelivery = useSelector(selectParameter);
  const dataClientRelated = useSelector(selectParameter2);
  const { id } = useParams();
  const paginationSet = useSelector(selectPagination);

  const [vehiclesFilter, setVehiclesFilter] = useState("");
  const [vehiclesFilterValue, setVehiclesFilterValue] = useState("");
  const [row, setRow] = useState(null);
  const [getData, setGetData] = useState(false);
  const [getDataVehivle, setGetDataVehicle] = useState(false);

  const [transFilter, setTransFilter] = useState("");
  const [transFilterValue, setTransFilterValue] = useState("");

  const [list, setList] = useState([]);
  const dataMenuTab = useSelector(selectMenuTab);

  //
  const [formValues, setFormValues] = useState({
    client: {
      value: "",
      error: false,
      required: "Y",
    },
    client_name: {
      value: "",
      error: false,
      required: "Y",
    },
    job_date: {
      value: dateDefault,
      error: false,
      required: "Y",
    },
    // ETD
    estimate_delivery: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    actual_delivery: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_loading: {
      value: "",
      error: false,
      required: "N",
    },

    port_of_loading_name: {
      value: "",
      error: false,
      required: "N",
    },

    job_type: {
      value: "",
      error: false,
      required: "Y",
    },
    //ETA
    estimate_arrival: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    actual_arrive: {
      value: dateDefault,
      error: false,
      required: "N",
    },
    service_class: {
      value: "",
      error: false,
      required: "Y",
    },
    port_of_discharge: {
      value: "",
      error: false,
      required: "N",
    },
    port_of_discharge_name: {
      value: "",
      error: false,
      required: "N",
    },
    remarks: {
      value: "",
      error: false,
      required: "N",
    },
  });

  // formVehicle
  const [formVehicle, setFormVehicle] = useState({
    party_id: {
      value: "",
      error: false,
      required: "N",
    },
    party_name: {
      value: "",
      error: false,
      required: "N",
    },
    party_code: {
      value: "",
      error: false,
      required: "N",
    },
    timezone: {
      value: "",
      error: false,
      required: "N",
    },
  });

  // party

  // formParty
  const [formParty, setFormParty] = useState({
    party_id: {
      value: "",
      error: false,
      required: "N",
    },
    party_type: {
      value: "",
      error: false,
      required: "Y",
    },
    party: {
      value: "",
      error: false,
      required: "Y",
    },
    party_name: {
      value: "",
      error: false,
      required: "",
    },
    address1: {
      value: "",
      error: false,
      required: "N",
    },
    address2: {
      value: "",
      error: false,
      required: "N",
    },
    city: {
      value: "",
      error: false,
      required: "N",
    },
    zip_code: {
      value: "",
      error: false,
      required: "N",
    },
    province: {
      value: "",
      error: false,
      required: "N",
    },
    country_id: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  // formTransport

  const [formTransport, setFormTransport] = useState({
    license_plate: {
      value: "",
      error: false,
      required: "N",
    },
    party_id: {
      value: "",
      error: false,
      required: "Y",
    },
    party_code: {
      value: "",
      error: false,
      required: "N",
    },

    party_name: {
      value: "",
      error: false,
      required: "",
    },
    driver_name: {
      value: "",
      error: false,
      required: "N",
    },
    driver_contact: {
      value: "",
      error: false,
      required: "N",
    },
    description: {
      value: "",
      error: false,
      required: "N",
    },
  });

  //
  const [formFilterModal, setFormFilterModal] = useState({
    booking_date_start: {
      value: "",
      error: false,
      required: "N",
    },

    booking_date_end: {
      value: "",
      error: false,
      required: "N",
    },
    rsd_start: {
      value: "",
      error: false,
      required: "N",
    },
    rsd_end: {
      value: "",
      error: false,
      required: "N",
    },
    rad_start: {
      value: "",
      error: false,
      required: "N",
    },
    rad_end: {
      value: "",
      error: false,
      required: "N",
    },
  });

  useEffect(() => {
    async function fetchMyAPI() {
      // Fetch data on first load

      await dispatch(fetchIdOutbound(id));

      await dispatch(
        fetchMenuTab({
          menu_url: "/outbound/job",
        })
      );

      await dispatch(
        fetchParameter({
          paramgroup_code: "DELIVERY_ARRANGEMENT",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchParameter2({
          paramgroup_code: "ALL_PARTY",
          pageNo: 1,
          pageSize: -1,
        })
      );
      await dispatch(
        fetchCountryAll({
          is_enable: "Y",
          pageNo: 1,
          pageSize: -1,
        })
      );
    }
    fetchMyAPI();
  }, [dispatch]);

  useEffect(() => {
    if (dataId !== null) {
      setFormValues({
        client: {
          value: dataId.client,
          error: false,
          required: "Y",
        },
        client_name: {
          value: dataId.client_name,
          error: false,
          required: "Y",
        },
        job_date: {
          value:
            dataId.job_date === null
              ? null
              : moment(dataId.job_date).format("YYYY-MM-DD"),
          error: false,
          required: "Y",
        },
        // ETD
        estimate_delivery: {
          value:
            dataId.estimated_delivery === null
              ? null
              : moment(dataId.estimated_delivery).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        actual_delivery: {
          value:
            dataId.actual_delivery === null
              ? null
              : moment(dataId.actual_delivery).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },

        port_of_loading: {
          value: dataId.port_of_loading === null ? "" : dataId.port_of_loading,
          error: false,
          required: "N",
        },

        port_of_loading_name: {
          value:
            dataId.port_of_loading_name === null
              ? ""
              : dataId.port_of_loading_name,
          error: false,
          required: "N",
        },

        job_type: {
          value: dataId.job_type_name,
          error: false,
          required: "Y",
        },
        //ETA
        estimate_arrival: {
          value:
            dataId.estimated_arrive === null
              ? ""
              : moment(dataId.estimated_arrive).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        actual_arrive: {
          value:
            dataId.actual_arrive === null
              ? ""
              : moment(dataId.actual_arrive).format("YYYY-MM-DD"),
          error: false,
          required: "N",
        },
        service_class: {
          value: dataId.service_class_name,
          error: false,
          required: "Y",
        },
        port_of_discharge: {
          value:
            dataId.port_of_discharge === null ? "" : dataId.port_of_discharge,
          error: false,
          required: "N",
        },
        port_of_discharge_name: {
          value:
            dataId.port_of_discharge_name === null
              ? ""
              : dataId.port_of_discharge_name,
          error: false,
          required: "N",
        },
        remarks: {
          value: dataId.remarks,
          error: false,
          required: "N",
        },
      });

      dispatch(
        fetchOutboundParty({
          outbound_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      dispatch(
        fetchOutboundTransportations({
          outbound_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
      dispatch(
        fetchOutboundVehicle({
          outbound_id: id,
          pageNo: 1,
          pageSize: paginationSet,
        })
      );
    }
  }, [dataId]);

  useEffect(() => {
    if (dataMenuTab.length > 0) {
      const data = dataMenuTab.map((item) => item.menu_name);
      setList(data);
      dispatch(setPermisionList(data));
      const master = dataMenuTab.map((item, index) => {
        if (item.menu_name === "Picking") {
          return dispatch(setPermisionPicking(item.permissions));
        }
        if (item.menu_name === "Handover") {
          return dispatch(setPermisionHandover(item.permissions));
        }
        if (item.menu_name === "BTS") {
          return dispatch(setPermisionBts(item.permissions));
        }
      });
    }
  }, [dataMenuTab]);

  useEffect(() => {
    // Add number

    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      dataVehicle === null
        ? []
        : dataVehicle.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataVehicle(initData);
  }, [dataVehicle, pageSize, pageNo]);
  const [tableDataVehicle, setTableDataVehicle] = useState(dataVehicle);

  useEffect(() => {
    // Add number

    const pageBefore = pageSize * (pageNo - 1);
    const initData =
      dataParty === null
        ? []
        : dataParty.map((item, index) => {
            return {
              ...item,
              no: index + 1 + pageBefore,
            };
          });
    setTableDataParty(initData);
  }, [dataParty, pageSizeParty, pageNoParty]);
  const [tableDataParty, setTableDataParty] = useState(dataVehicle);
  console.log(dataParty, "dataParty");
  console.log(tableDataParty, "tableDataParty");
  // HanldeSave

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      outbound_id: id,
      client: formValues.client.value,
      job_date: formValues.job_date.value,
      // job_type: formValues.job_type.value,
      estimated_delivery: formValues.estimate_delivery.value,
      estimated_arrive: formValues.estimate_arrival.value,
      actual_delivery: formValues.actual_delivery.value,
      actual_arrive: formValues.actual_arrive.value,
      port_of_loading: formValues.port_of_loading.value,
      port_of_discharge: formValues.port_of_discharge.value,
      services_class: formValues.service_class.value,
      remarks: formValues.remarks.value,
    };

    try {
      const response = await dispatch(editOutbound(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const [showClient, setShowClient] = useState(false);
  const [showLocationMaster, setShowLocationMaster] = useState(false);
  const [showShipper, setShowShipper] = useState(false);

  const [typeLocation, setTypeLocation] = useState("");

  const [fields, setFields] = useState([
    {
      id: "",
      value: "",
      params: "",
      label: "",
      add: "N",
      editor: "text",
      remove: "N",
    },
  ]);

  const vehiclesOptions = [
    {
      value: "vin",
      label: "VIN",
    },
    {
      value: "von",
      label: "VON",
    },
    {
      value: "master_code",
      label: "Master Code ",
    },
    {
      value: "model_code",
      label: "Model Code ",
    },
    {
      value: "color_code",
      label: "Color Code ",
    },
  ];

  const transOptions = [
    {
      value: "driver_name",
      label: "Driver Name",
    },
    {
      value: "driver_contact",
      label: "Driver Contact",
    },
    {
      value: "license_plate",
      label: "Vehicle No.",
    },
    {
      value: "description",
      label: "Description ",
    },
  ];

  const handleChangeVehicles = (e) => {
    if (e === null) {
      e = undefined;
      setVehiclesFilter("");
    } else {
      setVehiclesFilter(e.value);
    }
  };

  const handleChangeTransFilter = (e) => {
    if (e === null) {
      e = undefined;
      setTransFilter("");
    } else {
      setTransFilter(e.value);
    }
  };

  const handleSearch = async () => {
    let params = {};

    params[vehiclesFilter] = vehiclesFilterValue;
    params.outbound_id = id;
    params.pageNo = 1;
    params.pageSize = 10;

    try {
      const response = await dispatch(fetchOutboundVehicle(params));
      if (response.payload.data.status === 200) {
        await window.scrollTo(0, 1500);
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChange = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};

      params[vehiclesFilter] = vehiclesFilterValue;
      params.outbound_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchOutboundVehicle(params));
        if (response.payload.data.status === 200) {
          await window.scrollTo(0, 1500);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
      setTableDataVehicle(result);
    }
  };

  const handleSearchTrans = async () => {
    let params = {};

    params[transFilter] = transFilterValue;
    params.outbound_id = id;
    params.pageNo = 1;
    params.pageSize = 10;

    try {
      const response = await dispatch(fetchOutboundTransportations(params));
      if (response.payload.data.status === 200) {
      } else {
        showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleTableChangeTrans = async (
    type,
    { page, sizePerPage, sortField, sortOrder, data }
  ) => {
    if (type === "pagination") {
      let params = {};
      params[transFilter] = transFilterValue;
      params.outbound_id = id;
      params.pageNo = page;
      params.pageSize = sizePerPage;
      try {
        const response = await dispatch(fetchOutboundTransportations(params));
        if (response.payload.data.status === 200) {
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        showErrorDialog(error.message);
      }
    } else {
      let result;
      if (sortOrder === "asc") {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return 1;
          } else if (b[sortField] > a[sortField]) {
            return -1;
          }
          return 0;
        });
      } else {
        result = data.slice().sort((a, b) => {
          if (a[sortField] > b[sortField]) {
            return -1;
          } else if (b[sortField] > a[sortField]) {
            return 1;
          }
          return 0;
        });
      }
    }
  };

  const options = {
    page: pageNo,
    sizePerPage: pageSize,
    showTotal: true,
    totalSize: totalRecord,
    sizePerPageList: sizePerPageList,
  };

  const optionsParty = {
    page: pageNoParty,
    sizePerPage: pageSizeParty,
    showTotal: true,
    totalSize: totalRecordParty,
    sizePerPageList: sizePerPageList,
  };

  const optionsTransportations = {
    page: pageNoTransportations,
    sizePerPage: pageSizeTransportations,
    showTotal: true,
    totalSize: totalRecordTransportations,
    sizePerPageList: sizePerPageList,
  };

  const handleDelete = async (e, row) => {
    const params = { outboundvehicle_id: `${row.outboundvehicle_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeOutboundVehicle({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchOutboundVehicle({
              outbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await dispatch(fetchIdOutbound(id));

          await window.scrollTo(0, 1200);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleDeleteParty = async (e, row) => {
    const params = { outboundcarrier_id: `${row.outboundcarrier_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeOutboundParty({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchOutboundParty({
              outbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
          await window.scrollTo(0, 850);
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={
              <Tooltip id="products-edit-tooltip">
                {dataId.outbound_status === "6110" ? "Edit" : "View"}
              </Tooltip>
            }
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => {
                setRow(row);
                setGetData(true);
                setShowVehicleEdit(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                {dataId.outbound_status !== "6110" ? (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
                ) : (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                )}
              </span>
            </div>
          </OverlayTrigger>
          {dataId.outbound_status === "6110" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDelete(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columns = [
    {
      text: "VIN",
      dataField: "vin",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "VON",
      dataField: "von",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Master Code",
      dataField: "master_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Code",
      dataField: "model_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Model Name",
      dataField: "model_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Color Code",
      dataField: "color_code_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Color Name",
      dataField: "color_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Booking No.",
      dataField: "booking_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Order No",
      dataField: "order_no",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },

    {
      text: "Delivery Arrangement",
      dataField: "delivery_arrangement",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Client",
      dataField: "client_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Booking Date",
      dataField: "booking_date",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "160px" },
    },
    {
      text: "RSD",
      dataField: "rsd",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "160px" },
    },
    {
      text: "RAD",
      dataField: "rad",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      formatter: formatDate,
      style: { minWidth: "160px" },
    },
    {
      text: "Carrier",
      dataField: "carrier",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Request Picking Timezone",
      dataField: "picking_timezone",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Accessories Installed",
      dataField: "accessories_installed",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const actionFormatterParty = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={
              <Tooltip id="products-edit-tooltip">
                {" "}
                {dataId.outbound_status === "6110" ? "Edit" : "View"}
              </Tooltip>
            }
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => {
                setRow(row);
                setPartyType("Outbound");
                setShowParty(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                {dataId.outbound_status !== "6110" ? (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
                ) : (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                )}
              </span>
            </div>
          </OverlayTrigger>

          {dataId.outbound_status === "6110" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDeleteParty(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columnsParty = [
    {
      text: "Party Type",
      dataField: "party_type",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Code",
      dataField: "party",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },

    {
      text: "Name",
      dataField: "party_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Address",
      dataField: "address1",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterParty,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  // modal Create vehicle
  const [showVehicle, setShowVehicle] = useState(false);
  const [showVehicleEdit, setShowVehicleEdit] = useState(false);
  const [showUpload, setShowUpload] = useState(false);

  const [fileName, setFileName] = useState("Upload Template File");
  const [file, setFile] = useState(null);
  const [tableData, setTableData] = useState([]);
  const [selectedRows, setSelectedRows] = useState([]);

  const [showCancel, setShowCancel] = useState(false);

  const handleConfirm = async () => {
    const params = {
      outbound_id: id,
    };
    try {
      const response = await dispatch(editOutboundConfirm(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const handleAmend = async () => {
    const params = {
      outbound_id: id,
    };
    try {
      const response = await dispatch(editOutboundAmend(params));
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };
  // handle UPload File
  const [showUploadView, setShowUploadView] = useState(false);
  const [rowUpload, setRowUpload] = useState(null);
  const [rowUploadStatus, setRowUploadStatus] = useState(null);

  const handleDownloadUploadProgress = async (row) => {
    if (row == null || row.data == null || !(row.data instanceof Array) || row.data.length <= 0) {
      return;
    }

    const columns = [
      {
        text: "VIN",
        dataField: "vin",
      },
      {
        text: "VON",
        dataField: "von",
      },
      {
        text: "Validate",
        dataField: "status_validate",
      },
      {
        text: "Remarks Validate",
        dataField: "remark_validate",
      },
    ];

    const headers = Object.keys(row.data[0]);
    const shownIndexes = headers.map((h, i) => columnsExportExcel.find((c) => c.dataField === h) != null ? i : null).filter(x => x != null);

    const payload = {
      FileName: `Upload Result ${row.file_name}`,
      SheetName: 'Outbound Vehicle',
      Data: [
        headers.filter((v, i) => shownIndexes.includes(i)).map((h) => columnsExportExcel.find((c) => c.dataField === h)?.text || h)
      ],
      ConditionalIndex: headers.filter((v, i) => shownIndexes.includes(i)).findIndex((h) => h === 'status_validate'),
      misc_header_id : row.misc_header_id,
      index_select : shownIndexes
    };
    // for (let i = 0; i < row.data.length; i++) {
    //   const rowData = Object.keys(row.data[i]).map((key) => {
    //     return row.data[i][key] || '';
    //   });
    //   payload.Data.push(rowData.filter((v, i) => shownIndexes.includes(i)));
    // }

    try {
      const response = await dispatch(fetchGenerateExcel(payload));
      
      if (response.payload.status === 200) {
        const blob = new Blob([response.payload.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(blob);
        link.download = `Upload Result ${row.file_name}.xlsx`;
        link.click();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      console.log("catch");
      showErrorDialog(error.message);
    }
  };

  const actionFileFormatter = (e, row, rowIndex) => {
    return (
      <div className="d-flex flex-nowrap">
        <OverlayTrigger
          overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
        >
          <a
            className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
            onClick={() => {
              setRowUploadStatus(row.status);
              setRowUpload(row);
              setShowUploadView(true);
            }}
          >
            <span className="svg-icon svg-icon-md svg-icon-light">
              <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
            </span>
          </a>
        </OverlayTrigger>
        {
          row.status === 'Completed' && (
            <OverlayTrigger
              overlay={<Tooltip id="vehicle-download-tooltip">Download</Tooltip>}
            >
              <a
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
                onClick={() => handleDownloadUploadProgress(row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Download.svg")} />
                </span>
              </a>
            </OverlayTrigger>
          )
        }
      </div>
    );
  };
  const columnsFile = [
    {
      text: "Uploaded File",
      dataField: "file_name",
    },
    {
      text: "Status",
      dataField: "status",
    },
    {
      text: "Action",
      dataField: "Action",
      formatter: actionFileFormatter,
    },
  ];

  // modal party
  const [showParty, setShowParty] = useState(false);
  const [partyType, setPartyType] = useState(false);
  const [rowParty, setRowParty] = useState(null);

  const deliveryOptions = dataDelivery.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const handleChangeDelivery = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["delivery_arrangement"]: {
        ...formValues["delivery_arrangement"],
        value,
      },
    });
  };

  const [selectedVehicle, setSelectedVehicle] = useState([]);

  // transpotration

  const [showTransportation, setShowTrasportation] = useState(false);
  const [showPartyTrans, setShowPartyTrans] = useState(false);

  const handleDeleteTrans = async (e, row) => {
    const params = [
      { outboundtransportation_id: `${row.outboundtransportation_id}` },
    ];
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(
          removeOutboundTransportations({ data: params })
        );
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await dispatch(
            fetchOutboundTransportations({
              outbound_id: id,
              pageNo: 1,
              pageSize: paginationSet,
            })
          );
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatterTrans = (e, row, rowIndex, formatExtraData) => {
    return (
      <>
        <div>
          <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
          >
            <div
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
              onClick={(e) => {
                setRow(row);
                setShowTrasportation(true);
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                {dataId.outbound_status !== "6110" ? (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/Search.svg")} />
                ) : (
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")} />
                )}
              </span>
            </div>
          </OverlayTrigger>
          {dataId.outbound_status === "6110" && (
            <OverlayTrigger
              overlay={<Tooltip id="products-delete-tooltip">Delete</Tooltip>}
            >
              <div
                className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                onClick={(e) => handleDeleteTrans(e, row)}
              >
                <span className="svg-icon svg-icon-md svg-icon-light">
                  <SVG src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")} />
                </span>
              </div>
            </OverlayTrigger>
          )}
        </div>
      </>
    );
  };

  const columnsTrans = [
    {
      text: "Vehicle No.",
      dataField: "license_plate",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Carrier",
      dataField: "party_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },

    {
      text: "Driver Name",
      dataField: "driver_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Driver’s Contact No.",
      dataField: "driver_contact",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },
    {
      text: "Description",
      dataField: "description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
      style: { minWidth: "160px" },
    },

    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatterTrans,
      align: "center",
      headerAlign: "center",
      style: { minWidth: "150px" },
    },
  ];

  const columnsWorkflow = [
    {
      text: "Activity",
      dataField: "activity",
    },

    {
      text: "Planned",
      dataField: "planned",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Pending",
      dataField: "pending",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Completed",
      dataField: "completed",
      formatter: formatQuantity,
      align: "right",
    },
    {
      text: "Cancelled",
      dataField: "cancelled",
      formatter: formatQuantity,
      align: "right",
    },

    {
      text: "Status",
      dataField: "status",
    },
  ];

  const rowEvents = {
    onClick: (e, row, rowIndex) => {
      if (dataId.outbound_status === "6140" && list.includes(row.activity)) {
        // Lakukan tindakan sesuai dengan aktivitas yang diizinkan
        if (row.activity === "Picking") {
          history.push(`/outbound/job/workflow/edit/${id}`, 0);
        }
        if (row.activity === "Handover") {
          history.push(`/outbound/job/workflow/edit/${id}`, 1);
        }
        if (row.activity === "Back To Storage") {
          history.push(`/outbound/job/workflow/edit/${id}`, 2);
        }
      }
    },
  };

  const handleStart = async () => {
    const params = {
      outbound_id: id,
      outbound_status: "6140",
    };
    try {
      const response = await dispatch(editOutboundStarWorkflow(params));
      console.log(response, "response");
      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await window.location.reload();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      {dataId && (
        <>
          <Card>
            <CardBody>
              <div className="d-flex justify-content-between">
                <p className=" font-size-h3 text-title-primary font-weight-boldest">
                  Outbound : {dataId.outbound_no}
                </p>
              </div>

              {/* Header */}

              <div
                className="m-2 d-flex bg-primary-dark align-items-center"
                style={{ borderRadius: "10px" }}
              >
                <div className="m-2 flex-fill font-weight-boldest text-center  text-white">
                  Job Date :{formatDate(dataId.job_date)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  Client : {dataId.client_name}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white ">
                  Status : {statusInboundFormatter(dataId.outbound_status_name)}
                </div>
                <div className="m-2 flex-fill font-weight-boldest text-center text-white">
                  <Dropdown>
                    <Dropdown.Toggle className="primary" id="dropdown-basic">
                      Action
                    </Dropdown.Toggle>

                    <Dropdown.Menu>
                      {dataId.outbound_status === "6110" && (
                        <>
                          <Dropdown.Item onClick={handleConfirm}>
                            Confirm
                          </Dropdown.Item>
                          <Dropdown.Item
                            onClick={(e) => {
                              setShowCancel(true);
                            }}
                          >
                            Cancel
                          </Dropdown.Item>
                        </>
                      )}

                      {dataId.outbound_status === "6130" &&
                        dataId.is_amend === "Y" && (
                          <Dropdown.Item onClick={handleAmend}>
                            Amend
                          </Dropdown.Item>
                        )}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>

              <ThemeProvider theme={formLabelsTheme}>
                <>
                  {/* Basic Detail */}
                  <div className="ml-2 mt-5">
                    <p className="font-weight-boldest">Basic Detail</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Job Date"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          type="date"
                          size="small"
                          fullWidth
                          name="job_date"
                          value={formValues.job_date.value}
                          onChange={handleChange}
                          error={formValues.job_date.error}
                          helperText={
                            formValues.job_date.error ? (
                              <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                                {iconError} {"This field is required"}
                              </FormHelperText>
                            ) : (
                              ""
                            )
                          }
                          disabled={
                            dataId.outbound_status !== "6110" ? true : false
                          }
                        />
                        <RedditTextField
                          label="Estimated Time of Delivery"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="estimate_delivery"
                          value={formValues.estimate_delivery.value}
                          onChange={handleChange}
                          disabled={
                            dataId.outbound_status !== "6110" ? true : false
                          }
                        />

                        <RedditTextField
                          label="Actual Time of Delivery"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="actual_delivery"
                          value={formValues.actual_delivery.value}
                          onChange={handleChange}
                          disabled={
                            dataId.outbound_status !== "6110" ? true : false
                          }
                        />

                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Port of Loading"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.port_of_loading_name.value}
                              readOnly
                              disabled={
                                dataId.outbound_status !== "6110" ? true : false
                              }
                            />
                          </Col>
                          {dataId.outbound_status === "6110" && (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1}>
                                <div>
                                  <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                    <span
                                      className="svg-icon svg-icon-md svg-icon-light"
                                      onClick={() => {
                                        setTypeLocation("loading");
                                        setGetData(true);
                                        setShowLocationMaster(true);
                                      }}
                                    >
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/Search.svg"
                                        )}
                                      />
                                    </span>
                                  </a>
                                </div>
                              </Col>
                              {formValues.port_of_loading_name.value !== "" && (
                                <Col xs={1} sm={1} md={1} lg={1}>
                                  <div
                                    style={{
                                      marginTop: "22px",
                                      marginRight: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setFormValues({
                                        ...formValues,
                                        ["port_of_loading"]: {
                                          ...formValues["port_of_loading"],
                                          value: "",
                                        },
                                        ["port_of_loading_name"]: {
                                          ...formValues["port_of_loading_name"],
                                          value: "",
                                        },
                                      });
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/x-square.svg"
                                        )}
                                      />
                                    </span>
                                  </div>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                        <RedditTextField
                          required
                          label="Service Class"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="services_class"
                          value={dataId.services_class_name}
                          disabled
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <RedditTextField
                          required
                          label="Job Type"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          name="Job Type"
                          value={dataId.job_type_name}
                          disabled
                        />
                        <RedditTextField
                          label="Estimated Time of Arrival"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="estimate_arrival"
                          value={formValues.estimate_arrival.value}
                          onChange={handleChange}
                          disabled={
                            dataId.outbound_status !== "6110" ? true : false
                          }
                        />
                        <RedditTextField
                          label="Actual Time of Arrival"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          fullWidth
                          size="small"
                          type="date"
                          name="actual_arrive"
                          value={formValues.actual_arrive.value}
                          onChange={handleChange}
                          disabled={
                            dataId.outbound_status !== "6110" ? true : false
                          }
                        />
                        <Row>
                          <Col xs={10} sm={3} md={9} lg={9}>
                            <RedditTextField
                              label="Port of Discharge"
                              className={classes.margin}
                              variant="filled"
                              id="reddit-input"
                              size="small"
                              fullWidth
                              value={formValues.port_of_discharge_name.value}
                              readOnly
                              disabled={
                                dataId.outbound_status !== "6110" ? true : false
                              }
                            />
                          </Col>
                          {dataId.outbound_status === "6110" && (
                            <>
                              <Col xs={1} sm={1} md={1} lg={1}>
                                <div>
                                  <a className=" display-flex btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mt-5">
                                    <span
                                      className="svg-icon svg-icon-md svg-icon-light"
                                      onClick={() => {
                                        setTypeLocation("discharge");
                                        setGetData(true);

                                        setShowLocationMaster(true);
                                      }}
                                    >
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/Search.svg"
                                        )}
                                      />
                                    </span>
                                  </a>
                                </div>
                              </Col>
                              {formValues.port_of_discharge_name.value !==
                                "" && (
                                <Col xs={1} sm={1} md={1} lg={1}>
                                  <div
                                    style={{
                                      marginTop: "22px",
                                      marginRight: "12px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setFormValues({
                                        ...formValues,
                                        ["port_of_discharge"]: {
                                          ...formValues["port_of_discharge"],
                                          value: "",
                                        },
                                        ["port_of_discharge_name"]: {
                                          ...formValues[
                                            "port_of_discharge_name"
                                          ],
                                          value: "",
                                        },
                                      });
                                    }}
                                  >
                                    <span className="svg-icon svg-icon-md svg-icon-primary mt-3">
                                      <SVG
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/New/x-square.svg"
                                        )}
                                      />
                                    </span>
                                  </div>
                                </Col>
                              )}
                            </>
                          )}
                        </Row>
                      </Col>
                    </Row>
                  </div>

                  <hr />

                  {/* Packages */}
                  <div>
                    <p className="font-weight-boldest">Packages</p>
                    <Row>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Total Vehicles </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_vehicle}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Net Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_netweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <RedditTextField
                          label="Remarks"
                          className={classes.margin}
                          variant="filled"
                          id="reddit-input"
                          size="small"
                          fullWidth
                          multiline
                          rows="4"
                          name="remarks"
                          value={formValues.remarks.value}
                          inputProps={{ maxLength: 150 }}
                          onChange={handleChange}
                          disabled={
                            dataId.outbound_status !== "6110" ? true : false
                          }
                        />
                      </Col>
                      <Col xs={12} sm={3} md={6} lg={6}>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Volume </b>
                          </Form.Label>
                          <Col sm={6}>
                            {" "}
                            <Form.Label className="mt-2">
                              <b>{dataId.total_volume}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                        <Form.Group as={Row}>
                          <Form.Label column sm={3}>
                            <b>Gross Weight </b>
                          </Form.Label>
                          <Col sm={6}>
                            <Form.Label className="mt-2">
                              <b>{dataId.total_grossweight}</b>
                            </Form.Label>
                          </Col>
                        </Form.Group>
                      </Col>
                    </Row>
                  </div>

                  {/* handleSave */}
                  {dataId.outbound_status === "6110" && (
                    <Row className="mt-6 justify-content-end">
                      <Button variant="primary" onClick={handleSave}>
                        Save
                      </Button>
                    </Row>
                  )}

                  <hr />
                  {/* Parties */}
                  <div className="mb-3">
                    <p className="font-weight-boldest">Parties</p>
                    {/* table */}
                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="party_id"
                      data={tableDataParty}
                      columns={columnsParty}
                      pagination={paginationFactory(optionsParty)}
                      onTableChange={handleTableChange}
                      hover
                    ></BootstrapTable>

                    {dataId.outbound_status === "6110" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary"
                          onClick={(e) => {
                            setPartyType("Outbound");
                            setShowParty(true);
                          }}
                        >
                          Add Parties
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  {/* Transportation */}
                  <div className="mb-3">
                    <p className="font-weight-boldest">Transportation</p>
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mt-3">Search By</div>
                      <div className="p-2" style={{ width: "180px" }}>
                        {" "}
                        <Select
                          options={transOptions}
                          value={getValueOptions(transFilter, transOptions)}
                          placeholder="Select"
                          onChange={handleChangeTransFilter}
                          required
                        />
                      </div>
                      <div className="p-2">
                        <Form.Control
                          type="text"
                          placeholder=""
                          onChange={(e) => setTransFilterValue(e.target.value)}
                          value={transFilterValue}
                        />
                      </div>
                      <div className="p-2">
                        {" "}
                        <Button variant="primary" onClick={handleSearchTrans}>
                          Search
                        </Button>
                      </div>
                    </div>

                    {/* table */}

                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="vehicle_id"
                      data={dataTransportations}
                      columns={columnsTrans}
                      pagination={paginationFactory(optionsTransportations)}
                      onTableChange={handleTableChangeTrans}
                      hover
                    ></BootstrapTable>

                    {dataId.outbound_status === "6110" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary"
                          onClick={(e) => {
                            setGetData(true);
                            setShowTrasportation(true);
                          }}
                        >
                          Input Transportation
                        </Button>
                      </Row>
                    )}
                  </div>

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">Vehicle</p>
                    <div className="d-flex justify-content-end">
                      <div className="p-2 mt-3">Search By</div>
                      <div className="p-2" style={{ width: "180px" }}>
                        {" "}
                        <Select
                          options={vehiclesOptions}
                          value={getValueOptions(
                            vehiclesFilter,
                            vehiclesOptions
                          )}
                          placeholder="Select"
                          onChange={handleChangeVehicles}
                          required
                        />
                      </div>
                      <div className="p-2">
                        <Form.Control
                          type="text"
                          placeholder=""
                          onChange={(e) =>
                            setVehiclesFilterValue(e.target.value)
                          }
                          value={vehiclesFilterValue}
                        />
                      </div>
                      <div className="p-2">
                        {" "}
                        <Button variant="primary" onClick={handleSearch}>
                          Search
                        </Button>
                      </div>
                    </div>

                    {/* table */}

                    <BootstrapTable
                      remote
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="vehicle_id"
                      data={tableDataVehicle}
                      columns={columns}
                      pagination={paginationFactory(options)}
                      onTableChange={handleTableChange}
                      hover
                    ></BootstrapTable>

                    {dataId.outbound_status === "6110" && (
                      <Row className="mt-6 justify-content-end">
                        <Button
                          variant="outline-primary mr-3"
                          onClick={(e) => {
                            setFileName("Upload Template File");
                            setFile(null);
                            setSelectedRows([]);
                            setTableData([]);
                            setShowUpload(true);
                          }}
                        >
                          Upload Vehicle
                        </Button>
                        <Button
                          variant="outline-primary"
                          onClick={(e) => {
                            setGetDataVehicle(true);
                            setShowVehicle(true);
                          }}
                        >
                          Retrive Vehicle
                        </Button>
                      </Row>
                    )}
                  </div>
                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">
                      Workflow of Outbound Job
                    </p>
                    <BootstrapTable
                      wrapperClasses="table-responsive"
                      classes="table table-head-custom table-vertical-center overflow-hidden"
                      bootstrap4
                      keyField="no"
                      data={dataId.workFlowOutboundJobs}
                      columns={columnsWorkflow}
                      rowEvents={rowEvents}
                      hover
                    />

                    {dataId.outbound_status === "6130" && (
                      <Row className="mt-6 justify-content-end">
                        <Button variant="outline-primary" onClick={handleStart}>
                          Start Workflow
                        </Button>
                      </Row>
                    )}
                  </div>

                  <hr />
                  <div className="mb-3">
                    <p className="font-weight-boldest">File Upload Progress</p>
                    <Row>
                      <Col md={4}>
                        <BootstrapTable
                          wrapperClasses="table-responsive"
                          classes="table table-head-custom table-vertical-center overflow-hidden"
                          bootstrap4
                          keyField="no"
                          data={
                            dataId.tableUploadOutbounds === null
                              ? []
                              : dataId.tableUploadOutbounds
                          }
                          columns={columnsFile}
                          hover
                        />
                      </Col>
                    </Row>
                  </div>
                </>
              </ThemeProvider>
            </CardBody>
          </Card>

          <ModalCreateVehicle
            isOpen={showVehicle}
            setShow={setShowVehicle}
            setFormValues={setFormVehicle}
            formValues={formVehicle}
            setFields={setFields}
            fields={fields}
            setGetData={setGetDataVehicle}
            getData={getDataVehivle}
            selectedRows={selectedVehicle}
            setSelectedRows={setSelectedVehicle}
            formFilterModal={formFilterModal}
            setFormFilterModal={setFormFilterModal}
          />

          <ModalCreateParty
            isOpen={showParty}
            setShow={setShowParty}
            setFormValues={setFormParty}
            formValues={formParty}
            setFields={setFields}
            fields={fields}
            row={row}
            setRow={setRow}
            id={id}
            partyType={partyType}
            setPartyType={setPartyType}
            statusSave={dataId.outbound_status === "6110" ? true : false}
          />

          <ModalCreateTranspotation
            isOpen={showTransportation}
            setShow={setShowTrasportation}
            setFormValues={setFormTransport}
            formValues={formTransport}
            setFields={setFields}
            fields={fields}
            row={row}
            setRow={setRow}
            id={id}
            showParty={showPartyTrans}
            setShowParty={setShowPartyTrans}
          />

          <OutboundCancel
            isOpen={showCancel}
            setShow={setShowCancel}
            id={id}
            name={dataId.outbound_no}
          />

          <ModalEditVehicle
            isOpen={showVehicleEdit}
            setShow={setShowVehicleEdit}
            row={row}
            setRow={setRow}
            setFormValues={setFormVehicle}
            formValues={formVehicle}
            setGetData={setGetData}
            getData={getData}
            id={id}
          />

          <VehicleUpload
            isOpen={showUpload}
            setShow={setShowUpload}
            fileName={fileName}
            setFileName={setFileName}
            file={file}
            setFile={setFile}
            tableData={tableData}
            setTableData={setTableData}
            id={id}
            selectedRows={selectedRows}
            setSelectedRows={setSelectedRows}
          />
          <VehicleUploadView
            isOpen={showUploadView}
            setShow={setShowUploadView}
            setRowUpload={setRowUpload}
            rowUpload={rowUpload}
            rowUploadStatus={rowUploadStatus}
            setRowUploadStatus={setRowUploadStatus}
          />
          <ModalLocationMasterRadio
            isOpen={showLocationMaster}
            setShow={setShowLocationMaster}
            setFormValues={setFormValues}
            formValues={formValues}
            setFields={setFields}
            fields={fields}
            typeLocation={typeLocation}
            setTypeLocation={setTypeLocation}
            setGetData={setGetData}
            getData={getData}
          />
        </>
      )}
    </>
  );
};
